import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export const CARD = "rounded-xl border border-slate-200/80 bg-white shadow-sm";

// Remembers each section's open/closed state between visits.
export function useOpen(id, initial) {
  const key = `daily.open.${id}`;
  const [open, setOpen] = useState(() => {
    try { const v = localStorage.getItem(key); return v == null ? initial : v === "1"; } catch { return initial; }
  });
  const toggle = () => setOpen((o) => {
    try { localStorage.setItem(key, o ? "0" : "1"); } catch { /* storage unavailable */ }
    return !o;
  });
  return [open, toggle];
}

export default function Collapse({ id, title, icon, summary, defaultOpen = false, testId, children }) {
  const [open, toggle] = useOpen(id, defaultOpen);
  return (
    <section className={CARD} data-testid={testId}>
      <button type="button" onClick={toggle} aria-expanded={open} className="flex w-full items-center gap-3 p-4 text-left">
        {open ? <ChevronDown size={18} className="shrink-0" /> : <ChevronRight size={18} className="shrink-0" />}
        {icon}
        <span className="font-display font-bold text-lg text-slate-900">{title}</span>
        {summary && <span className="ml-auto truncate text-xs text-slate-500">{summary}</span>}
      </button>
      {open && <div className="border-t border-slate-100 px-5 pb-5 pt-4">{children}</div>}
    </section>
  );
}
